<template>
  <div data-qa="chosen-accessories-card">
    <quote-list-block
      :empty-result-label="i18n.t('/ProductBlocks/EmptyOptionsResultLabel')"
      :class="rowClass"
    >
      <template v-if="rows.length" #header>
        <div class="vat">{{ i18n.t('/Common/Btw') }}</div>
        <div v-if="showExclPrice" class="price price-excl" data-qa="accessories-price-excl-header">
          {{ i18n.t('/Common/ExclBtw') }}
        </div>
        <div v-if="showInclPrice" class="price price-incl" data-qa="accessories-price-incl-header">
          {{ i18n.t('/Common/InclBtw') }}
        </div>
      </template>

      <template v-if="rows.length" #body>
        <chosen-accessory-row
          v-for="(row, index) in rows"
          :key="`${row.accessory.OptionType_ID || 'custom'}-${row.accessory.Index}-${index}`"
          :accessory="row.accessory"
          :catalog-item="row.catalogItem"
          :is-editable="isEditable"
          :show-incl-price="showInclPrice"
          :show-excl-price="showExclPrice"
          @edit="$emit('edit', $event)"
          @remove="$emit('remove', $event)"
        />
      </template>

      <template v-if="isEditable" #footer>
        <app-button data-qa="open-accessory-catalog-button" @click="$emit('open-catalog')">
          {{ i18n.t('/AccessoryCatalog/OpenCatalogButton') }}
        </app-button>
        <app-button data-qa="add-DealerAccessories-product-button" @click="$emit('new-accessory')">
          {{ i18n.t('/ProductBlocks/DealerAccessories/AddButton') }}
        </app-button>
      </template>
    </quote-list-block>
  </div>
</template>

<script>
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import QuoteListBlock from '@/components/generic/presentational/molecules/quoteListBlock/QuoteListBlock.vue'
import ChosenAccessoryRow from '@/components/generic/presentational/molecules/accessoryCatalog/ChosenAccessoryRow.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    AppButton,
    QuoteListBlock,
    ChosenAccessoryRow,
  },
  props: {
    /** Array of { accessory, catalogItem } — quote row joined with its catalog match */
    rows: {
      type: Array,
      default: () => [],
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['edit', 'remove', 'open-catalog', 'new-accessory'],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    ...mapGetters({
      showInclPrice: 'quote/isPriceShowIncl',
      showExclPrice: 'quote/isPriceShowExcl',
    }),
    // Mirrors SelectedProducts: drop the column that the price display mode hides
    rowClass() {
      if (!this.showInclPrice) return 'row-price-excl'
      if (!this.showExclPrice) return 'row-price-incl'
      return ''
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/mixins/quote-row-grid';

:deep(.header.row) {
  @include quote-row-grid(thumb title vat price-excl price-incl buttons);
}

.row-price-incl :deep(.header.row) {
  @include quote-row-grid(thumb title vat price-incl buttons);
}

.row-price-excl :deep(.header.row) {
  @include quote-row-grid(thumb title vat price-excl buttons);
}
</style>
